import { useEffect } from 'react'

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | Bas Menninga` : 'Bas Menninga — singer-songwriter, piano- & gitaardocent in Huizen'
  }, [title])
}
